import { render, staticRenderFns } from "./Deep.vue?vue&type=template&id=c781bb0a&scoped=true"
import script from "./Deep.vue?vue&type=script&lang=js"
export * from "./Deep.vue?vue&type=script&lang=js"
import style0 from "./Deep.vue?vue&type=style&index=0&id=c781bb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c781bb0a",
  null
  
)

export default component.exports